import React from 'react';
import './EmailSupportModal.css';

export default function EmailSupportModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:support@blackkiteai.com';
  };

  return (
    <div className="email-support-modal-overlay" onClick={handleOverlayClick}>
      <div className="email-support-modal">
        <button className="email-support-modal-close" onClick={onClose}>
          ✕
        </button>
        
        <div className="email-support-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#EA4335"/>
          </svg>
        </div>
        
        <h2 className="email-support-modal-title">Email Support</h2>
        
        <p className="email-support-modal-message">
          Please send us your request or query to{' '}
          <a 
            href="mailto:support@blackkiteai.com" 
            className="email-support-link"
            onClick={handleEmailClick}
          >
            support@blackkiteai.com
          </a>
        </p>
        
        <p className="email-support-modal-submessage">
          We will respond to you shortly.
        </p>
        
        <div className="email-support-modal-actions">
          <button className="btn-modal btn-modal-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
